export default __webpack_public_path__ + "static/herbestemming-desktop-ef57cecf9eccc4ca9ab69613a4bcbe2b.svg";